module.exports = __webpack_public_path__ + "media/images/swifticons/weather-sunny-comment-b42a6eb7c165be5ee195c062cce05ab7.svg";